<template>
  <div>
    <v-chart
        :force-fit="true"
        :height="height"
        :data="chartData"
        :scale="scale"
    >
      <v-tooltip :htmlContent="htmlContent"/>
      <v-axis/>
      <v-legend/>
      <v-line position="tradeDate*value" color="type"/>
    </v-chart>
  </div>
</template>

<script>
import {numberFormat, numberFormat2} from '../../utils'

const DataSet = require('@antv/data-set');

const CLIMATE_INDEX = '金司南气候友好'
const CLIMATE_INDEX_EN = 'SHJIF Climate Friendly'

const CSI_300 = '沪深300'
const CSI_300_EN = 'CSI 300'




const createChartData = (originalData, lang) => {
  if (!originalData) return []
  const dv = new DataSet.View().source(originalData);
  dv.transform({
    type: 'map',
    callback: function callback(row) {
      let date = row.tradeDate;
      if (date && date.length === 8)
        row.tradeDate = `${date.substr(0, 4)}-${date.substr(4, 2)}-${date.substr(6, 2)}`
      row.close = Number(row.close);
      return row;
    }
  }).transform({
    type: "rename",
    map: {
      close: lang === 'en' ? CLIMATE_INDEX_EN : CLIMATE_INDEX,
      // comparedClose: lang ==='en' ? CSI_300_EN : CSI_300,
    }
  }).transform({
    type: 'fold',
    // fields: lang ==='en' ? [CLIMATE_INDEX_EN, CSI_300_EN] : [CLIMATE_INDEX,CSI_300],
    fields: lang === 'en' ? [CLIMATE_INDEX_EN] : [CLIMATE_INDEX],
    key: 'type',
    value: 'value',
  });
  const data = dv.rows;
  return data
}
const scale = [{
  value: {
    nice: true
  },
}];

export default {
  props: ['originalData'],
  data() {
    return {
      scale,
      height: 500,
      style: {stroke: '#fff', lineWidth: 1},
    };
  },
  computed: {
    lang() {
      return this.$store.state.plang;
    },
    chartData() {
      return createChartData(this.originalData, this.lang)
    }
  },
  methods: {
    htmlContent(title, items) {
      const {x, y, name, point} = items[0];
      const {value, change, indexCode, low, tradeDate, turnOver, volume} = point._origin || {};
      const lang = this.lang;
      return `
        <div
          class="pc-g2-point-wrap"
          style="position: absolute; top: ${y}px; left: ${x}px;"
        >
            <div class="name-box">${name}<span>（${indexCode}）</span></div>
            <p>${tradeDate}</p>
            <p class="close-box">${lang == 'zh' ? '收' : 'Close'}：${value}</p>
            <p>${lang == 'zh' ? '涨跌' : 'Change'}：${change}${change ? '%' : ''}</p>
            <p>${lang == 'zh' ? '成交量' : 'Trading Volume'}：${numberFormat2(volume, lang)}</p>
            <p>${lang == 'zh' ? '成交额' : 'Trading Value'}：${numberFormat(turnOver, lang)}</p>
        </div>
      `;
    }
  }
};
</script>
<style lang="less">
.pc-g2-point-wrap {
  //width: 300px;
  transition: visibility 0.2s cubic-bezier(0.23, 1, 0.32, 1) 0s, left 0.4s cubic-bezier(0.23, 1, 0.32, 1) 0s, top 0.4s cubic-bezier(0.23, 1, 0.32, 1) 0s;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 0 10px #aaa;
  padding: 15px;
  font-size: 14px;
  div, p {
    margin-bottom: 10px;
  }

  .name-box {
    padding-left: 15px;
    position: relative;

    &:before {
      display: inline-block;
      content: '';
      width: 10px;
      height: 10px;
      background: #037698;
      border-radius: 50%;
      position: absolute;
      left: 0;
      top: 5px;
    }

    span {
      font-size: 12px;
      color: #999;
    }
  }

  p {
    font-size: 12px;
    color: #666;
    padding-left: 15px;
  }

  .close-box {
    position: relative;

    &:before {
      display: inline-block;
      content: '';
      width: 2px;
      height: 2px;
      border-radius: 50%;
      position: absolute;
      left: 0;
      top: 3px;
      border: 4px solid red;
    }
  }
}
</style>
